module.exports = __webpack_public_path__ + "static/media/medical-service-companies-main.14202266.jpg";